module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_5010.0ccfe549.png";